import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssabilAdminRoutingModule } from './assabil-admin-routing.module';
import { AssabilAdminMenuComponent } from './assabil-admin-menu/assabil-admin-menu.component';
import { BankListComponent } from './components/control-tables/bank-list/bank-list.component';
import { PartnerSiteListComponent } from './components/master-data/partner/partner-site-list/partner-site-list.component';
import { PartnerSiteWidgetComponent } from './components/master-data/partner/partner-site-widget/partner-site-widget.component';
import { PartnerListComponent } from './components/master-data/partner/partner-list/partner-list.component';
import { PartnerWidgetComponent } from './components/master-data/partner/partner-widget/partner-widget.component';
import { PartnerLovComponent } from './components/master-data/partner/partner-lov/partner-lov.component';
import { PriceListListComponent } from './components/master-data/product/price-list-list/price-list-list.component';
import { PriceListWidgetComponent } from './components/master-data/product/price-list-widget/price-list-widget.component';
import { ProductListComponent } from './components/master-data/product/product-list/product-list.component';
import { ProductLovComponent } from './components/master-data/product/product-lov/product-lov.component';
import { ProductCategoryLovComponent } from './components/control-tables/product-category-lov/product-category-lov.component';
import { ProductOptionListComponent } from './components/master-data/product/product-option-list/product-option-list.component';
import { ProductOptionWidgetComponent } from './components/master-data/product/product-option-widget/product-option-widget.component';
import { ProductProductOptionWidgetComponent } from './components/master-data/product/product-product-option-widget/product-product-option-widget.component';
import { ProductWidgetComponent } from './components/master-data/product/product-widget/product-widget.component';
import { PartnerCategoryListComponent } from './components/control-tables/partner-category-list/partner-category-list.component';
import { PartnerCategoryWidgetComponent } from './components/control-tables/partner-category-widget/partner-category-widget.component';
import { ItineraryListComponent } from './components/master-data/partner/itinerary-list/itinerary-list.component';
import { ItineraryWidgetComponent } from './components/master-data/partner/itinerary-widget/itinerary-widget.component';
import { RoleLovComponent } from './components/master-data/role/role-lov/role-lov.component';
import { RoleListComponent } from './components/master-data/role/role-list/role-list.component';
import { ProfileLovComponent } from './components/master-data/profile/profile-lov/profile-lov.component';
import { PersonListComponent } from './components/master-data/person/person-list/person-list.component';
import { ProductCategoryListComponent } from './components/control-tables/product-category-list/product-category-list.component';
import { PersonLovComponent } from './components/master-data/person/person-lov/person-lov.component';
import { VatListComponent } from './components/control-tables/vat-list/vat-list.component';
import { PartnerAnalysisGroup1ListComponent } from './components/control-tables/partner-analysis-group1-list/partner-analysis-group1-list.component';
import { PartnerAnalysisGroup2ListComponent } from './components/control-tables/partner-analysis-group2-list/partner-analysis-group2-list.component';
import { PartnerAnalysisGroup3ListComponent } from './components/control-tables/partner-analysis-group3-list/partner-analysis-group3-list.component';
import { PartnerAnalysisGroup4ListComponent } from './components/control-tables/partner-analysis-group4-list/partner-analysis-group4-list.component';
import { PartnerAnalysisGroup5ListComponent } from './components/control-tables/partner-analysis-group5-list/partner-analysis-group5-list.component';
import { ProductAnalysisGroup1ListComponent } from './components/control-tables/product-analysis-group1-list/product-analysis-group1-list.component';
import { ProductAnalysisGroup2ListComponent } from './components/control-tables/product-analysis-group2-list/product-analysis-group2-list.component';
import { ProductAnalysisGroup3ListComponent } from './components/control-tables/product-analysis-group3-list/product-analysis-group3-list.component';
import { ProductAnalysisGroup4ListComponent } from './components/control-tables/product-analysis-group4-list/product-analysis-group4-list.component';
import { ProductAnalysisGroup5ListComponent } from './components/control-tables/product-analysis-group5-list/product-analysis-group5-list.component';
import { BrandListComponent } from './components/control-tables/brand-list/brand-list.component';
import { VisitResultListComponent } from './components/control-tables/visit-result-list/visit-result-list.component';
import { CancelationReasonListComponent } from './components/control-tables/cancelation-reason-list/cancelation-reason-list.component';
import { CurrencyListComponent } from './components/control-tables/currency-list/currency-list.component';
import { BankNoteListComponent } from './components/control-tables/bank-note-list/bank-note-list.component';
import { ItineraryTypeListComponent } from './components/control-tables/itinerary-type-list/itinerary-type-list.component';
import { LanguageListComponent } from './components/control-tables/language-list/language-list.component';
import { PaymentTermListComponent } from './components/control-tables/payment-term-list/payment-term-list.component';
import { ProductLogisticGroupListComponent } from './components/control-tables/product-logistic-group-list/product-logistic-group-list.component';
import { ProductPageComponent } from './components/control-tables/product-page/product-page.component';
import { ProductSalesGroupListComponent } from './components/control-tables/product-sales-group-list/product-sales-group-list.component';
import { PeriodListComponent } from './components/control-tables/period-list/period-list.component';
import { ProductAttributeGroupComponent } from './components/control-tables/product-attribute-group/product-attribute-group.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TermListComponent } from './components/control-tables/term-list/term-list.component';
import { FormListComponent } from './components/control-tables/form-list/form-list.component';
import { FormWidgetComponent } from './components/control-tables/form-widget/form-widget.component';
import { TermLovComponent } from './components/control-tables/term-lov/term-lov.component';
import { ProductCategoryWidgetComponent } from './components/control-tables/product-category-widget/product-category-widget.component';
import { ToolsModule } from '../tools/tools.module';
import { AssabilMenuListComponent } from './components/control-tables/assabil-menu-list/assabil-menu-list.component';
import { ProfileListComponent } from './components/master-data/profile/profile-list/profile-list.component';
import { ProfileWidgetComponent } from './components/master-data/profile/profile-widget/profile-widget.component';
import { AssabilMenuLovComponent } from './components/control-tables/assabil-menu-lov/assabil-menu-lov.component';
import { ProductEntryComponent } from './components/master-data/product/product-entry/product-entry.component';
import { RoleWidgetComponent } from './components/master-data/role/role-widget/role-widget.component';
import { GeoAreaListComponent } from './components/control-tables/geoarea-list/geoarea-list.component';
import { GeoAreaTypeListComponent } from './components/control-tables/geoarea-type-list/geoarea-type-list.component';
import { GeoAreaLovComponent } from './components/control-tables/geo-area-lov/geo-area-lov.component';
import { DeviceLovComponent } from './components/control-tables/device-lov/device-lov.component';
import { TokenSerieLovComponent } from './components/control-tables/token-serie-lov/token-serie-lov.component';
import { BranchListComponent } from './components/control-tables/branch/branch-list/branch-list.component';
import { BranchWidgetComponent } from './components/control-tables/branch/branch-widget/branch-widget.component';
import { BranchLovComponent } from './components/control-tables/branch/branch-lov/branch-lov.component';
import { PartnerAnalysisGroup1LovComponent } from './components/control-tables/partner-analysis-group1-lov/partner-analysis-group1-lov.component';
import { PartnerAnalysisGroup5LovComponent } from './components/control-tables/partner-analysis-group5-lov/partner-analysis-group5-lov.component';
import { PartnerAnalysisGroup2LovComponent } from './components/control-tables/partner-analysis-group2-lov/partner-analysis-group2-lov.component';
import { PartnerAnalysisGroup3LovComponent } from './components/control-tables/partner-analysis-group3-lov/partner-analysis-group3-lov.component';
import { PartnerAnalysisGroup4LovComponent } from './components/control-tables/partner-analysis-group4-lov/partner-analysis-group4-lov.component';
import { SalesChannelListComponent } from './components/control-tables/sales-channel-list/sales-channel-list.component';
import { PaymentTermLovComponent } from './components/control-tables/payment-term-lov/payment-term-lov.component';
import { ProductAttributeGroupLovComponent } from './components/control-tables/product-attribute-group-lov/product-attribute-group-lov.component';
import { BankLovComponent } from './components/control-tables/bank-lov/bank-lov.component';
import { SalesChannelLovComponent } from './components/control-tables/sales-channel-lov/sales-channel-lov.component';
import { PriceListLovComponent } from './components/master-data/product/price-list-lov/price-list-lov-.component';
import { ProductAttributeGroupParamLovComponent } from './components/control-tables/product-attribute-group-pram-lov/product-attribute-group-param-lov.component';
import { ProductAttributeListComponent } from './components/control-tables/product-attribute-list/product-attribute-list.component';
import { ProductSalesGroupLovComponent } from './components/control-tables/product-sales-group-lov/product-sales-group-lov.component';
import { ProductLogisticGroupLovComponent } from './components/control-tables/product-logistic-group-lov/product-logistic-group-lov.component';
import { ItineraryLovComponent } from './components/master-data/partner/itinerary-lov/itinerary-lov.component';
import { WarehouseTransferReasonListComponent } from './components/control-tables/warehouse-transfer-reason-list/warehouse-transfer-reason-list.component';
import { WarehouseLovComponent } from './components/control-tables/branch/warehouse-lov/warehouse-lov.component';
import { PeriodLovComponent } from './components/control-tables/period-lov/period-lov.component';
import { BatchLovComponent } from './components/master-data/product/batch-lov/batch-lov.component';


@NgModule({
  declarations: [
    AssabilMenuListComponent,
    AssabilAdminMenuComponent,
    BankListComponent,
    BranchListComponent,
    BranchWidgetComponent,
    PartnerSiteListComponent,
    PartnerSiteWidgetComponent,
    PartnerListComponent,
    PartnerWidgetComponent,
    PartnerLovComponent,
    PriceListListComponent,
    PriceListWidgetComponent,
    ProductListComponent,
    ProductLovComponent,
    ProductCategoryLovComponent,
    ProductOptionListComponent,
    ProductOptionWidgetComponent,
    ProductProductOptionWidgetComponent,
    ProductWidgetComponent,
    PartnerCategoryListComponent,
    PartnerCategoryWidgetComponent,
    ItineraryListComponent,
    ItineraryWidgetComponent,
    RoleLovComponent,
    RoleListComponent,
    ProfileLovComponent,
    PersonListComponent,
    ProductCategoryListComponent,
    PersonLovComponent,
    BranchLovComponent,
    VatListComponent,
    PartnerAnalysisGroup1ListComponent,
    PartnerAnalysisGroup2ListComponent,
    PartnerAnalysisGroup3ListComponent,
    PartnerAnalysisGroup4ListComponent,
    PartnerAnalysisGroup5ListComponent,
    ProductAnalysisGroup1ListComponent,
    ProductAnalysisGroup2ListComponent,
    ProductAnalysisGroup3ListComponent,
    ProductAnalysisGroup4ListComponent,
    ProductAnalysisGroup5ListComponent,
    BrandListComponent,
    VisitResultListComponent,
    CancelationReasonListComponent,
    CurrencyListComponent,
    BankNoteListComponent,
    ItineraryTypeListComponent,
    LanguageListComponent,
    PaymentTermListComponent,
    ProductAttributeListComponent,
    ProductLogisticGroupListComponent,
    ProductPageComponent,
    ProductSalesGroupListComponent,
    SalesChannelListComponent,
    PeriodListComponent,
    ProductAttributeGroupComponent,
    TermListComponent,
    FormListComponent,
    FormWidgetComponent,
    TermLovComponent,
    ProductCategoryWidgetComponent,
    ProfileListComponent,
    ProfileWidgetComponent,
    AssabilMenuLovComponent,
    ProductEntryComponent,
    RoleWidgetComponent,
    GeoAreaListComponent,
    GeoAreaTypeListComponent,
    GeoAreaLovComponent,
    WarehouseLovComponent,
    DeviceLovComponent,
    TokenSerieLovComponent,
    PartnerAnalysisGroup1LovComponent,
    PartnerAnalysisGroup2LovComponent,
    PartnerAnalysisGroup3LovComponent,
    PartnerAnalysisGroup4LovComponent,
    PartnerAnalysisGroup5LovComponent,
    PaymentTermLovComponent,
    SalesChannelLovComponent,
    ProductAttributeGroupLovComponent,
    BankLovComponent,
    PriceListLovComponent,
    ProductAttributeGroupParamLovComponent,
    ProductSalesGroupLovComponent,
    ProductLogisticGroupLovComponent,
    ItineraryLovComponent,
    WarehouseTransferReasonListComponent,
    PeriodLovComponent,
    BatchLovComponent,
  ],
  exports: [
    ProductLovComponent,
    PartnerLovComponent,
    RoleLovComponent,
    ProductCategoryLovComponent,
    BranchLovComponent,
    AssabilAdminMenuComponent,
    ProductEntryComponent,
    GeoAreaLovComponent,
    WarehouseLovComponent,
    DeviceLovComponent,
    TokenSerieLovComponent,
    BatchLovComponent,
  ],
  imports: [
    CommonModule,
    ToolsModule,
    AssabilAdminRoutingModule,
    NgxDatatableModule
  ],
  entryComponents:[
    TermLovComponent,
    PartnerLovComponent,
    ProductLovComponent,
    ProfileLovComponent,
    RoleLovComponent,
    PersonLovComponent,
    BranchLovComponent,
    ProductCategoryLovComponent,
    AssabilMenuLovComponent,
    GeoAreaLovComponent,
    WarehouseLovComponent,
    DeviceLovComponent,
    TokenSerieLovComponent,
    PartnerAnalysisGroup1LovComponent,
    PartnerAnalysisGroup2LovComponent,
    PartnerAnalysisGroup3LovComponent,
    PartnerAnalysisGroup4LovComponent,
    PartnerAnalysisGroup5LovComponent,
    PaymentTermLovComponent,
    SalesChannelLovComponent,
    ProductAttributeGroupLovComponent,
    BankLovComponent,
    PriceListLovComponent,
    ProductAttributeGroupParamLovComponent,
    ProductSalesGroupLovComponent,
    ProductLogisticGroupLovComponent,
    ItineraryLovComponent,
    PeriodLovComponent,
    BatchLovComponent
  ]
})
export class AssabilAdminModule { }
